import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Newspaper } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BlogPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="blog-page">
      <Helmet defer={false}>
        <title>Blog | LYNKO</title>
        <meta name="description" content="Le blog LYNKO : conseils, actualités et guides autour de l'informatique professionnelle pour TPE/PME." />
        <link rel="canonical" href="https://lynko.info/blog" />
      </Helmet>
      <Header />

      {/* Hero */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-700 py-14 lg:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl lg:text-4xl font-bold text-white mb-3">Blog</h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Conseils, actualités et guides autour de l'informatique professionnelle.
          </p>
        </div>
      </section>

      {/* Articles (vide pour l'instant) */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="bg-white rounded-2xl shadow-sm border border-dashed border-gray-200 p-12 lg:p-20 text-center"
            data-testid="blog-empty-state"
          >
            <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Newspaper className="w-8 h-8 text-blue-500" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Aucun article pour le moment</h2>
            <p className="text-gray-600 max-w-md mx-auto">
              Les premiers articles arrivent bientôt. Revenez nous voir prochainement !
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
